import { useEffect, useState, Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { INITIAL_PREVIEW } from './store/initialData';
import Head from "./layouts/Header";
import Foot from "./layouts/Footer";

import './style/Core.scss';

const Body = lazy(() => import("./layouts/Body"));
const ViewPokemon = lazy(() => import("./layouts/ViewPokemon"));

function App() {
  const [displayedPokemon, setDisplayedPokemon] = useState(INITIAL_PREVIEW);
  const [filterState, setFilterState] = useState({ type: '', value: 'all' });
  const [theme, setTheme] = useState(localStorage.getItem('pokedex-theme') ?? 'light');
  const [favourites, setFavourites] = useState(() => {
    const saved = localStorage.getItem('poke_favourites');
    return saved ? JSON.parse(saved) : [];
  });
  const [fullPokemons, setFullPokemons] = useState([]);
  const [allPokemons, setAllPokemons] = useState([]);
  
  const handleFilterSelect = (filterKey, filterType) => {
    setFilterState({ type: filterType, value: filterKey });
    
    if (!filterKey || filterKey === "all") {
      setDisplayedPokemon(fullPokemons);
      return;
    }
    
    if (filterKey === 'favourites') {
      const filtered = allPokemons.filter(p => favourites.includes(p.name));
      setDisplayedPokemon(filtered);
      return;
    }
    const allowedNames = filterType === "game-selector" 
      ? allPokemons.filter(p => p.regions?.[filterKey]).sort((a, b) => a.regions[filterKey] - b.regions[filterKey])
      : fullPokemons.filter(p => p.gen === filterKey);

    if (!allowedNames) return;
    
    const orderedResult = allowedNames.map(pokemon => {
      return allPokemons.find(p => p.name === pokemon.name);
    }).filter(Boolean);

    setDisplayedPokemon(orderedResult);
  };
  useEffect(() => {
    setDisplayedPokemon(fullPokemons);
  }, [fullPokemons]);
  useEffect(() => {
    const savedTheme = localStorage.getItem('pokedex-theme');
    if (savedTheme) {
      document.documentElement.setAttribute('data-theme', savedTheme);
    } else {
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      localStorage.setItem('pokedex-theme', prefersDark ? 'dark' : 'light');
      setTheme(prefersDark ? 'dark' : 'light');
      document.documentElement.setAttribute('data-theme', prefersDark ? 'dark' : 'light');
    }
    import("./store/collection").then((module) => {
      const { fullPokemons, variantPokemons } = module;
      
      setFullPokemons(fullPokemons);
      setAllPokemons(fullPokemons.concat(variantPokemons));
      setDisplayedPokemon(prev => prev.length <= 12 ? fullPokemons : prev);
    });
  }, []);
  useEffect(() => {
    localStorage.setItem('poke_favourites', JSON.stringify(favourites));
  }, [favourites]);
  useEffect(() => {
    if (filterState.value === 'favourites') {
      const filtered = allPokemons.filter(p => favourites.includes(p.name));
      setDisplayedPokemon(filtered);
    }
  }, [favourites, filterState.value, allPokemons]);

  const toggleFavourites = (e, pokemonName) => {
    e.preventDefault();
    e.stopPropagation();
    setFavourites(prev => 
      prev.includes(pokemonName)
      ? prev.filter(name => name !== pokemonName)
      : [...prev, pokemonName]
    );
  }
  
  return (
    <Router>
      <Head />
      <Suspense fallback={null}>
        
        <Routes>
          <Route path="/" element={
            <Body
              data={displayedPokemon}
              onFilterelect={handleFilterSelect}
              currentFilter={filterState}
              toggleFavourites={toggleFavourites}
              favourites={favourites}
            />}
          />
          <Route path="/:name" element={
            <ViewPokemon
              theme={theme}
              pokemonByGame={allPokemons}
            />} />
        </Routes>

      </Suspense>
      <Foot theme={theme} setTheme={setTheme} />
    </Router>
  );
}

export default App;